import React, { useState } from "react";
import { Doughnut, Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import moment from "moment";
import DatePicker from "react-datepicker";
import { useForm, Controller } from "react-hook-form";
import { useQuery } from "react-query";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [fromDate, setFromDate] = useState(moment().toDate());
  const [toDate, setToDate] = useState(moment().toDate());
  const { control, handleSubmit } = useForm();

  const navigate = useNavigate();
  // Fetching dashboard data with selected dates
  const fetchDashBoardDetails = async (fromDate, toDate) => {
    const formattedFromDate = moment(fromDate).format("YYYY-MM-DD");
    const formattedToDate = moment(toDate).format("YYYY-MM-DD");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_HOST}/dashboard/overallReport?from=${formattedFromDate}&to=${formattedToDate}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching dashboard details:", error);
      throw error;
    }
  };

  // React Query hook to fetch dashboard data based on selected dates
  const {
    data: dashBoardDetails,
    isLoading: dashboardLoading,
    isError: dashboardError,
  } = useQuery(
    ["dashboard", fromDate, toDate],
    () => fetchDashBoardDetails(fromDate, toDate),
    {
      enabled: moment(fromDate).isValid() && moment(toDate).isValid(),
      refetchOnWindowFocus: false,
    }
  );

  // Register required chart components
  ChartJS.register(ArcElement, Tooltip, Legend);

  const data = {
    datasets: [
      {
        label: "Sales Report",
        data: [dashBoardDetails?.totalOrderPrice || 0, 100],
        backgroundColor: ["#FFFFFF", "#2196F3"],
        borderWidth: 0.5,
        borderColor: ["#2196F3", "#2196F3"],
        hoverOffset: 4,
      },
    ],
  };

  const purchase = {
    datasets: [
      {
        label: "Purchase Report",
        data: [dashBoardDetails?.totalPurchase || 0, 100],
        backgroundColor: ["#FFFFFF", "#BA68C8"],
        borderWidth: 0.5,
        borderColor: ["#BA68C8", "#BA68C8 "],
        hoverOffset: 4,
      },
    ],
  };
  const product = {
    datasets: [
      {
        label: "Purchase Report",
        data: [dashBoardDetails?.totalPurchase || 0, 100],
        backgroundColor: ["#FFFFFF", "#AB47BC"],
        borderWidth: 0.5,
        borderColor: ["#AB47BC", "#AB47BC"],
        hoverOffset: 4,
      },
    ],
  };
  const incentive = {
    datasets: [
      {
        label: "Purchase Report",
        data: [dashBoardDetails?.totalPurchase || 0, 100],
        backgroundColor: ["#FFFFFF", "#FFB74D"],
        borderWidth: 0.5,
        borderColor: ["#FFB74D", "#FFB74D"],
        hoverOffset: 4,
      },
    ],
  };
  const overall = {
    datasets: [
      {
        label: "Over All",
        data: [dashBoardDetails?.overallReport || 0, 100],
        backgroundColor: ["#FFFFFF", "#FFCC80"],
        borderWidth: 0.5,
        borderColor: ["#FFCC80", "#FFCC80"],
        hoverOffset: 4,
      },
    ],
  };

  console.log("das", dashBoardDetails);

  return (
    <>
      <div className="d-flex justify-content-end align-items-center gap-2 mt-3 px-3">
        <Controller
          name="fromDate"
          control={control}
          render={({ field }) => (
            <DatePicker
              {...field}
              selected={fromDate}
              onChange={(date) => {
                setFromDate(date);
                field.onChange(date);
              }}
              dateFormat="MMMM d, yyyy"
              className="border rounded p-2 w-full"
              maxDate={moment().toDate()}
              minDate={new Date("1970-01-01")} // Allow all past dates
              showYearDropdown
              yearDropdownItemNumber={50}
              scrollableYearDropdown
            />
          )}
        />
        <label>&nbsp; To &nbsp;</label>
        <Controller
          name="toDate"
          control={control}
          render={({ field }) => (
            <DatePicker
              {...field}
              selected={toDate}
              onChange={(date) => {
                setToDate(date);
                field.onChange(date);
              }}
              dateFormat="MMMM d, yyyy"
              className="border rounded p-2 w-full"
              maxDate={moment().toDate()}
              minDate={new Date("1970-01-01")}
              showYearDropdown
              yearDropdownItemNumber={50}
              scrollableYearDropdown
            />
          )}
        />
      </div>
      <div className="dashboard_main_block">
        <div className="dashboad_sub_block">
          <div className="dashboad_card" onClick={() => {
            navigate("/salesReport")
          }}>
            <div style={{ width: "120px", height: "120px" }}>
              <Doughnut data={data} />
            </div>
            <h6 style={{ color: "#1565C0", fontSize: "24px", fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif" }}>
              Sales Report
            </h6>
          </div>
          <div className="dashboad_card"
            onClick={() => {
              navigate("/purchaseReport")
            }}
          >
            <div style={{ width: "120px", height: "120px" }}>
              <Doughnut data={purchase} />
            </div>
            <h6 style={{ color: "#6A1B9A", fontSize: "24px" }}>
              Purchase Report
            </h6>
          </div>
          <div className="dashboad_card"
            onClick={() => {
              navigate("/productReport")
            }}
          >
            <div style={{ width: "120px", height: "120px" }}>
              <Doughnut data={product} />
            </div>
            <h6 style={{ color: "#4A148C", fontSize: "24px" }}>
              Product Report
            </h6>
          </div>
          <div className="dashboad_card" onClick={() => {
            navigate("/incentiveReport")
          }}>
            <div style={{ width: "120px", height: "120px" }}>
              <Doughnut data={incentive} />
            </div>
            <h6 style={{ color: "#E65100", fontSize: "24px" }}>
              Incentive Report
            </h6>
          </div>
          <div className="dashboad_card">
            <div style={{ width: "120px", height: "120px" }}>
              <Doughnut data={overall} />
            </div>
            <h6 style={{ color: "#BF360C", fontSize: "24px" }}>
              Overall Report
            </h6>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
